

import BaseControlView from 'BaseControlView.js';
import contentTemplate from 'common-visuals/control-hello-world.ejs';


class HelloWorldView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = contentTemplate;
        this.tagName = 'div';
        //this.propViews = opts.propViews;


        this.listenTo(this.model, 'change', this.render);

        return this;
    }


    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }


}

export default HelloWorldView;
